import type { RootState } from "@src/store/rootState";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const { getTargetUrl, getTargetThemeId, isAuthenticated } =
  experienceBuilderSlice.selectors;

export const getEmbeddedPreviewSrc = (state: RootState): string | undefined => {
  const targetUrl = getTargetUrl(state);
  if (!targetUrl) return undefined;

  try {
    const url = new URL(targetUrl);

    // Theme preview only means anything on the org's own store: the id names a
    // theme in *that* shop. While a demo URL is set the preview points
    // somewhere else, so applying it would put the org's theme id in an
    // unrelated merchant's request log and hand their storefront a theme it
    // has never heard of. Gated here rather than by clearing `targetThemeId`,
    // so the selection survives turning demo mode back off — and so no future
    // writer of that field can reintroduce the leak.
    const themeId = getTargetThemeId(state);
    if (themeId && isAuthenticated(state)) {
      url.searchParams.set("preview_theme_id", String(themeId));
      url.searchParams.set("pb", "0");
    }

    return url.href;
  } catch {
    return undefined;
  }
};
